import { updateObject } from 'utils/updateObject'
import {
  CAMPAIGNS_CLEAN,
  CAMPAIGNS_LOAD_DATA_FAILED,
  SET_CAMPAIGNS_LIST,
  YANDEX_SUBSCRIPTION_CAMPAIGN_DELETED,
} from 'modules/Services/types'

const initialState = {
  loading: true,
  campaigns: [],
}
const setCampaignsList = (state, { payload }) => {
  return updateObject(state, payload)
}

const campaignsLoadDataFailed = (state) => {
  return updateObject(state, { loading: false, campaigns: [] })
}

const campaignsClean = (state) => {
  return updateObject(state, { loading: true, campaigns: [] })
}

const campaignDeleted = (state, { payload }) => {
  return updateObject(state, {
    campaigns: [
      ...state.campaigns.filter(
        (campaign) => campaign.id !== payload.campaignId,
      ),
    ],
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAMPAIGNS_LIST:
      return setCampaignsList(state, action)
    case CAMPAIGNS_LOAD_DATA_FAILED:
      return campaignsLoadDataFailed(state)
    case CAMPAIGNS_CLEAN:
      return campaignsClean(state)
    case YANDEX_SUBSCRIPTION_CAMPAIGN_DELETED:
      return campaignDeleted(state, action)
    default:
      return state
  }
}

export default reducer
